import React, { useEffect, useState, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { FiMapPin, FiHome } from 'react-icons/fi'
import { getCommunityDetail } from '../services/Api'
import Properties from '../components/Properties'
import Developers from '../components/Developers'
import ContactForm from '../components/ContactForm'
import { Link,useNavigate } from 'react-router-dom'
import { FaBed } from 'react-icons/fa';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';



import { GlobalContext } from '../GlobalContext';
import axiosInstance from "../services/BaseUrl";


export default function CommunityDetailsPage() {
  const { idOrSlug } = useParams()
  const [community, setCommunity] = useState(null)
  const [properties, setProperties] = useState([])
  const navigate = useNavigate();
  const {globalVar, setGlobalVar} = useContext(GlobalContext)
  const [page, setPage] = useState(1);
const [isLoading, setIsLoading] = useState(false);
const [hasMore, setHasMore] = useState(true);
const { t, i18n } = useTranslation();



const [allCommunities, setAllCommunities] = useState([]); // Use this as your base dataset

  const [filteredCommunities, setFilteredCommunities] = useState([]); // Optional: if you want to show filtered ones

  const [minPrice, setMinPrice] = useState('');

  const [maxPrice, setMaxPrice] = useState('');

  const [sending, setSending] = useState(false);
  
const fetchCommunityDetail = async (newPage = 1, reset = false) => {
  try {
    setIsLoading(true);
    // Set pageSize to 12 to fetch the first set of properties
    const response = await getCommunityDetail(idOrSlug, newPage, 12);
    
    if (response.success) {
      const data = response.data;
      const community = data.community;
      setCommunity(community);
      setHasMore(!!response.next); // Check if there's a next page
      const newProperties = data.properties || [];
      setProperties(reset ? newProperties : [...properties, ...newProperties]);
    } else {
      console.error("Community Details not found");
    }
  } catch (error) {
    console.error("Failed to fetch community details:", error);
  } finally {
    setIsLoading(false);
  }
};

const handleLoadMore = () => {
  const nextPage = page + 1;
  setPage(nextPage);
  fetchCommunityDetail(nextPage);
};


      const handleClearFilter = () => {
    setMinPrice('');
    setMaxPrice('');
    setProperties(allCommunities); // Reset to all
  };

const handleApplyFilter = () => {
    const min = minPrice ? parseFloat(minPrice) : 0;
    const max = maxPrice ? parseFloat(maxPrice) : Infinity;

    const filtered = allCommunities.filter((community) => {
    const price = parseFloat(community.lowest_price || community.price || 0);
      return price >= min && price <= max;
    });

    setProperties(filtered); // Update the displayed list
  };

  useEffect(() => {
    fetchCommunityDetail();
  }, [idOrSlug])

  const getImageUrl = (path) => `${globalVar}/${path}`;

  if (!community) {
    return <p className="p-8 text-center">Loading community details...</p>;
  }

  return (
    <div className="min-h-screen bg-gray-50">


      {/* Banner */}
      {community?.images && (
       <div
          className="h-96 bg-cover bg-center relative"
          style={{
            backgroundImage: `url(${
              community?.first_property?.images?.[0]?.image
                ? getImageUrl(community.first_property.images[0].image)
                : community?.images?.[0]?.image
                  ? getImageUrl(community.images[0].image)
                  : '/placeholder.jpg'
            })`
          }}
        >
         <div className="absolute inset-0 bg-black/40" />
         <div className="absolute bottom-6 left-8 text-white">
           <h1>{t(`communities.${community.slug}`, community.name)}</h1>

           <div className="flex items-center space-x-4 mt-2 text-sm">
            <div><FiMapPin className="inline mr-1"/> {community.properties_count} {t('communities.projects')}</div>

             {/* {community.developer?.name && (
                <div><FiHome className="inline mr-1" /> {community.developer.name}</div>
              )} */}
           </div>
         </div>
       </div>
      )}

        {/* <div className="absolute inset-0 bg-black/40" />
        <div className="absolute bottom-6 left-8 text-white">
            <h1 className="text-4xl font-bold">{community.name}</h1>
            <div className="flex items-center space-x-4 mt-2 text-sm">
              <div><FiMapPin className="inline mr-1" /> {properties.properties_count}  Properties</div>
              
              {community.developer?.name && (
                <div><FiHome className="inline mr-1" /> {community.developer.name}</div>
              )}

            </div>
          </div>
        </div> */}

<div className="max-w-5xl mx-auto mt-10 w-full px-4 sm:px-6">
  <label className="block text-lg font-semibold text-gray-800 mb-3">
    {t('communities.price_range', 'Price Range')}
  </label>

  <div className="flex flex-col sm:flex-row sm:items-center sm:gap-4 gap-3">
    <input
      type="number"
      placeholder="From (AED)"
      value={minPrice}
      onChange={(e) => setMinPrice(e.target.value)}
      className="w-full sm:w-auto flex-1 px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
    />

    <span className="text-gray-600 text-center sm:text-left">–</span>

    <input
      type="number"
      placeholder="To (AED)"
      value={maxPrice}
      onChange={(e) => setMaxPrice(e.target.value)}
      className="w-full sm:w-auto flex-1 px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
    />

    <div className="flex gap-2 sm:mt-0 mt-2 flex-wrap">
      <button
        onClick={handleApplyFilter}
        className="w-full sm:w-auto px-6 py-2 bg-teal-500 text-white font-medium rounded-lg hover:bg-teal-600 transition"
      >
       {t('communities.apply_filter', 'Apply Filter')}

      </button>
      <button
        onClick={handleClearFilter}
        className="w-full sm:w-auto px-6 py-2 border border-gray-300 text-gray-800 font-medium rounded-lg hover:bg-gray-100 transition"
      >
        {t('communities.clear_filter', 'Clear Filter')}

      </button>
    </div>
  </div>
</div>

      {/* Info */}
      <div className="max-w-7xl mx-auto px-4 py-12 grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Left */}
        <div className="space-y-8 lg:col-span-2">
          {/* <section>
            <h2 className="text-2xl font-semibold mb-2">About {community.name}</h2>
            <p className="text-gray-700">{community.description || 'No description available.'}</p>
          </section> */}

          {/* <section>
            <h2 className="text-2xl font-semibold mb-2">Location</h2>
            <div className="aspect-video overflow-hidden rounded-xl shadow">
              <iframe
                width="100%"
                height="100%"
                frameBorder="0"
                src={`https://www.google.com/maps?q=${encodeURIComponent(community.name)}@${community.lat},${community.lng}&z=14&output=embed`}
                allowFullScreen
                title="Google Map"
              />
            </div>
          </section> */}
        </div>

        {/* Right */}
        {/* <aside className="space-y-6 ">
          <div className="bg-white p-6 rounded-xl shadow">
            <h3 className="text-xl font-semibold mb-4">Overview</h3>
            <ul className="space-y-2 text-gray-700 mb-6">
              <li><span className="font-medium">Established:</span> {community.established_year || '—'}</li>
              <li><span className="font-medium">Properties:</span> {community.properties_count}</li>
              <li><span className="font-medium">Developer:</span> {community.developer?.name || '—'}</li>
            
              <li><span className="font-medium">Emirate:</span> {community.location.emirate}</li>
            </ul>
          </div>

        </aside> */}

 {/* Contact Form */}


        {/* <aside className="space-y-6">
          <div className="bg-white p-6 rounded-xl shadow">
            <h3 className="text-xl font-semibold mb-4">Overview</h3>
            <ul className="space-y-2 text-gray-700">
              <li><span className="font-medium">Established:</span> {community.established_year || '—'}</li>
              <li><span className="font-medium">Properties:</span> {community.properties_count}</li>
              <li><span className="font-medium">Developer:</span> {community.developer?.name || '—'}</li>
              <li><span className="font-medium">City:</span> {community.location.city}</li>
              <li><span className="font-medium">Emirate:</span> {community.location.emirate}</li>
            </ul>
          </div>
        </aside> */}
      </div>

      {/* Property List */}
      <section className="max-w-7xl mx-auto px-4 pb-12">
  <h2 className="text-2xl font-semibold mb-6"> {t('communities.projects')} {t('communities.in')} {t(`communities.${community.slug}`, community.name)}</h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
    {properties.length === 0 ? (
      <div className="text-gray-600 col-span-full text-center">
        {t('communities.no_properties', 'No properties available')}
      </div>
    ) : (
      properties.map((property) => (
                        <Link
                            key={property.id}
                            to={`/property-detail/${property.id}`}
                            className="block bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition"
                        >
                            <div className="relative">
                                <img
                                    src={
                                        property.images?.[0]?.image
                                            ? property.images[0].image.startsWith('/media')
                                                ? `${globalVar}${property.images[0].image}`
                                                : property.images[0].image
                                            : '/placeholder.jpg'
                                    }
                                    alt="Property"
                                    className="h-50 w-100 object-cover"
                                />

                                {/* Category */}
                                <span className="absolute top-2 left-2 bg-black bg-opacity-60 text-white text-xs font-medium px-2 py-1 rounded">
                                    {property.category?.name || 'Category'}
                                </span>

                                {/* Delivery Date */}
                                {property.delivery_date && (
                                    <span className="absolute top-2 right-2 bg-white text-black text-xs font-semibold px-2 py-1 rounded shadow-md">
                                        {new Date(property.delivery_date).toISOString().split('T')[0]}
                                    </span>
                                )}
                                 {property.sales_status === 'Sold Out' && (
                <span className="absolute bottom-2 right-2 bg-red-600 text-white text-xs font-semibold px-2 py-1 rounded shadow-md z-10">
                  Sold Out
                </span>
              )}
                            </div>

                            <div className="p-4 space-y-1">
                                {/* Price + Unit Type */}
                                <div className="flex justify-between items-center text-sm text-gray-800 font-semibold">
                                    <span className="text-black">
                                        AED {(Math.round(property.price)).toLocaleString()}
                                    </span>
                                    <span className="text-gray-600 text-xs">
                                        {
                                            [...new Set(property.units?.map(unit => unit.unit_type))]
                                                .filter(Boolean)
                                                .join(', ') || property.property_type?.name || ''
                                        }
                                    </span>

                                </div>

                                {/* Title */}
                                <h3 className="text-md font-semibold text-gray-800 line-clamp-1">
                                    {property.title}
                                </h3>

                                {/* Location + Community */}
                                <p className="text-sm text-gray-500">
                                    {property.location?.emirate}
                                    {property.community?.name ? ` / ${property.community.name}` : ''}
                                </p>

                                <div className="flex justify-between items-center text-sm text-gray-600 mt-2">
                                    <span className="flex items-center gap-1">
                                        <FaBed className="text-gray-500" />
                                        {
                                            [...new Set(property.units?.map(unit => unit.rooms))]
                                                .filter(room => room)
                                                .sort((a, b) => Number(a) - Number(b))
                                                .join(', ')
                                        }
                                    </span>
                                    <span>{property.area_sqft} sqft</span>
                                </div>
                            </div>
                        </Link>
                    ))
                )}
{hasMore && (
  <div className="mt-10 text-center">
    <button
      onClick={handleLoadMore}
      disabled={isLoading}
      className="px-8 py-3 bg-teal-500 hover:bg-teal-600 text-white font-medium rounded-full transition"
    >
      {isLoading ? "Loading..." : "Load More"}
    </button>
  </div>
)}

    
  </div>

</section>
      <section className="max-w-7xl mx-auto px-4 pb-12">
<ContactForm
  propertyTitle={community.name}
  propertySlug={community.slug}
  developerName={community.developer?.name || ""}
  customMessage=""  // Make sure customMessage is not used here
  isPlaceholderMessageEnabled={false}   // New prop to prevent default message in this page
/>




      </section>
      <Footer/>
    </div>
  )
}
